<template>
  <div class="battery-mgmt">
    <div class="main-title">
      <p v-if="view=='list'" @click="cancelHandle">优惠套餐</p>
      <p v-if="view=='add'" @click="cancelHandle">优惠套餐</p>
      <p v-if="view=='add'">>新增</p>
      <p v-if="view=='edit'" @click="cancelHandle">优惠套餐</p>
      <p v-if="view=='edit'">>编辑</p>
    </div>
    <div class="main-body" v-if="view=='list'">
      <div class="list">
        <span>套餐编号：</span>
        <el-input class="list-input" size="mini" v-model="number" placeholder="请输入编号"></el-input>
        <span class="ml10">套餐状态：</span>
        <el-select class="fixed-width-200"
                   clearable
                   v-model="status">
          <el-option
            v-for="item in statusList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10">所属组织：</span>
        <el-cascader
          :options="unitList"
          :props="{ checkStrictly: true, value:'unitNo',label:'name',children:'subUnit' }" v-model="unitNo"
          clearable></el-cascader>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="onAddBtnClick">新增</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="170px">编号</th>
          <th>名称</th>
          <th>所属组织</th>
          <th>套餐商品</th>
          <th>总金额</th>
          <th width="200px">有效期</th>
          <th>套餐状态</th>
          <th width="168px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.number }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.unitName }}</td>
          <td>{{ item.standard }}</td>
          <td>{{ item.price }}</td>
          <td>{{ item.startTime ? item.startTime + '到' + item.endTime : '无限制' }}</td>
          <td>{{ statusList[item.status].text }}</td>
          <td>
            <div class="text-btn fixed-width-75" @click="onEditBtnClick(item)">编辑</div>
            <div class="text-btn fixed-width-75" @click="onDeleteBtnClick(item)">删除</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="8">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
    <div class="main-body" v-if="view == 'add'">
      <combo-add-view @addSuccess="addSuccessHandle" @cancel="cancelHandle"></combo-add-view>
    </div>
    <div class="main-body" v-if="view == 'edit'">
      <combo-edit-view :editData="editData" @editSuccess="editSuccessHandle" @cancel="cancelHandle"></combo-edit-view>
    </div>
  </div>
</template>

<script>
import ComboAddView from "./comboAddView";
import ComboEditView from "./comboEditView";

export default {
  name: 'combo',
  components: {ComboEditView, ComboAddView},
  data() {
    return {
      view: "list",
      number: "",
      status: '',
      statusList: [{
        id: '',
        text: '全部'
      }, {
        id: '1',
        text: '在售'
      }, {
        id: '2',
        text: '停售'
      }],
      unitNo: '',
      unitList: [],
      pageSize: 10,
      beginIndex: 0,
      preBtnDisabled: true,
      nextBtnDisabled: true,
      dataList: [],
      editData: {}
    }
  },
  mounted() {
    if (this.$route.query.number) {
      this.number = this.$route.query.number;
    }
    this.queryCommodityList();
    this.getUnitMember();
  },
  methods: {
    queryCommodityList: function () {
      let self = this;
      let params = {
        number: this.number,
        status: this.status,
        type: 11,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http.post('/managementPlatform/admin/queryCommodity', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryCommodityList();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryCommodityList();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryCommodityList();
    },
    onAddBtnClick() {
      this.view = 'add';
    },
    onEditBtnClick(data) {
      this.view = 'edit';
      this.$nextTick(() => {
        this.editData = data;
      });
    },
    addSuccessHandle() {
      this.view = 'list';
      this.beginIndex = 0;
      this.queryCommodityList();
    },
    editSuccessHandle() {
      this.view = 'list';
      this.queryCommodityList();
    },
    cancelHandle() {
      this.view = 'list';
      this.queryCommodityList();
    },
    onDeleteBtnClick(item) {
      let self = this;
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        self.deleteCommodity(item.number);
      }).catch(() => {

      });
    },
    deleteCommodity(number) {
      let self = this;
      let params = {
        number: number
      };
      this.$http.post('/managementPlatform/admin/deleteCommodity', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "删除失败!",
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "删除成功!",
          center: true
        });
        self.queryCommodityList();
      }).catch(function (response) {
        console.log(response);
      });
    },
    getUnitMember() {
      let self = this;
      this.$http.post('/managementPlatform/unit/queryManagedUnit'
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.unitList = res.mdata.unitTree;
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.main-body {
  .list {
    line-height: 30px;
    margin: 20px 30px 10px;

    .name-label {
      float: left;
    }

    .value-label {
      display: inline-block;
      height: 30px;
    }

    .date-global {
      width: 185px;
    }

    .list-input {
      width: 180px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .fixed-width-200 {
      width: 200px;
    }

    .fixed-width-300 {
      width: 300px;
    }
  }

  .table-custom {
    .text-btn {
      width: 50px;
      height: 24px;
      line-height: 24px;
      color: #417505;
      display: inline-block;
      background-color: #BEE6B3;
      cursor: pointer;
    }

    .fixed-width-75 {
      width: 75px;
    }

    .fixed-width-100 {
      width: 100px;
    }

    .mt4 {
      margin-top: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commodityMgmt/combo.vue